import React from 'react'
import {SvgIcon} from 'rambler-ui'

export default function HelpIcon(props) {
  return (
    <SvgIcon {...props} viewBox="0 0 15 15">
      <path d="M3.492 12.357A6.271 6.271 0 0 0 7.5 13.8a6.271 6.271 0 0 0 4.008-1.443l-1.279-1.28A4.48 4.48 0 0 1 7.5 12a4.48 4.48 0 0 1-2.73-.922l-1.278 1.279zm-.849-.849l1.28-1.279A4.48 4.48 0 0 1 3 7.5a4.48 4.48 0 0 1 .922-2.73L2.643 3.493A6.271 6.271 0 0 0 1.2 7.5c0 1.521.542 2.919 1.443 4.008zm9.714-8.016l-1.28 1.279A4.48 4.48 0 0 1 12 7.5a4.48 4.48 0 0 1-.922 2.73l1.279 1.278A6.271 6.271 0 0 0 13.8 7.5a6.271 6.271 0 0 0-1.443-4.008zm-.849-.849A6.271 6.271 0 0 0 7.5 1.2a6.271 6.271 0 0 0-4.008 1.443l1.279 1.28A4.48 4.48 0 0 1 7.5 3a4.48 4.48 0 0 1 2.73.922l1.278-1.279zM7.5 0a7.5 7.5 0 1 1 0 15 7.5 7.5 0 0 1 0-15zm0 4.2c-1.82 0-3.3 1.48-3.3 3.3 0 1.82 1.48 3.3 3.3 3.3 1.82 0 3.3-1.48 3.3-3.3 0-1.82-1.48-3.3-3.3-3.3z" />
    </SvgIcon>
  )
}
